import React from "react";
import "./Preloader.css";

const Preloader = ({ isLoading, onEnter }) => {
  return (
    <div className={`preloader ${isLoading ? "show" : "hide"}`}>
      <div className="preloader-inner">
        <div className="preloader-badge">
          <div className="preloader-ring"></div>

          <div className="preloader-content">
            <div className="preloader-logo">Fairuz</div>
            <div className="preloader-sub">Enter the collage experience</div>

            <button
              type="button"
              className="preloader-btn"
              onClick={onEnter}
            >
              Enter Fairuz World
            </button>
          </div>
        </div>

        <div className="preloader-eq" aria-hidden="true">
          <span />
          <span />
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default Preloader;